/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './requestPhoneVerification.defs.js'
export * as $defs from './requestPhoneVerification.defs.js'
